import React from "react";

import ProcessingSpinner from "core/ProcessingSpinner";

import colors from "core/colors";
import { StyledProcessingScreen, ProcessingAnimationContainer } from "./styles";

import { convertPxToRem } from "frontend/components/helpers";

const ProcessingScreen = () => {
    return (
        <>
            <StyledProcessingScreen />
            <ProcessingAnimationContainer>
                <ProcessingSpinner
                    iconColor={colors.primary.diamond}
                    width={convertPxToRem({ px: 23 })}
                    height={convertPxToRem({ px: 23 })}
                />
            </ProcessingAnimationContainer>
        </>
    );
};

export default ProcessingScreen;
